import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserToken } from 'domain/entities/UserEntity';
import { AppSocket } from 'utilities/websocket/WebSocket';

const initialState: AppSocket = new AppSocket();

interface SocketEvent {
    name: string;
    callback: (event: any) => void;
}

export interface SocketOpenEvent {
    url: string;
    user: UserToken;
    additionaOpenEvent?: () => void;
}

export const socketSlice = createSlice({
    name: 'socketSlice',
    initialState,
    reducers: {
        connecSocket: (state, action: PayloadAction<SocketOpenEvent>) => {
            state.connect(action.payload.url);
            state.on('open', () => {
                state.initSocketAttributes(action.payload.user);
                action.payload.additionaOpenEvent && action.payload.additionaOpenEvent();
            });
            //TODO remove console.log
            state.on('error', (error: any) => {
                console.log('error', error);
            });
            state.on('close', () => {
                console.log('close');
            });
            return state;
        },

        listenSocketEvent: (state, action: PayloadAction<SocketEvent>) => {
            state.on(action.payload.name, action.payload.callback);
            return state;
        },

        closeSocket: (state) => {
            state.disconnect();
            return state;
        },

        sendSocket: (state, action: PayloadAction<any>) => {
            state.send(JSON.stringify(action.payload));
            return state;
        },
        pingSocket: (state, action: PayloadAction<UserToken>) => {
            state.initSocketAttributes(action.payload);
            return state;
        },
    },
});

export const { connecSocket, listenSocketEvent, closeSocket, sendSocket, pingSocket } =
    socketSlice.actions;
export default socketSlice.reducer;
